module.exports = "/img/10.12da70.jpg";